import * as Sentry from '@sentry/browser';

const sentryTracker = (event, payload) => {
  Sentry.withScope(scope => {
    Object.keys(payload).forEach(key => {
      scope.setExtra(key, payload[key]);
      if (key === 'message' && typeof payload[key] === 'string') {
        scope.setTag('message', payload[key]);
      }
    });
    Sentry.captureMessage(event);
  });
};

export default sentryTracker;
